'use client';

import BaseModal from './BaseModal';
import SimplePricing from '@/components/anyvideo/SimplePricing';

const SimplePricingModal = ({ isOpen, onClose }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-4xl overflow-hidden rounded-xl border border-gray-700/50 bg-gray-900/95 shadow-xl backdrop-blur-sm"
    >
      {/* 简洁的顶部装饰条 */}
      <div className="h-0.5 w-full bg-gradient-to-r from-green-500 to-cyan-500" />

      {/* 内容区域 */}
      <div className="p-4">
        <SimplePricing />
      </div>
    </BaseModal>
  );
};

export default SimplePricingModal; 